/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0d5676281734b2dde44b2aa3de6a257984069339";
